module.exports = __webpack_public_path__ + "img/xiantiao.1bf8f802.png";